<template>
	<loge>
		<!-- SidebarSearch Form -->
		<div class="form-inline">
			<div class="input-group">
				<input v-model="name" class="form-control form-control-sidebar" type="search" placeholder="搜索我的概览"
					aria-label="Search">
			</div>
		</div>
		<!-- Sidebar Menu -->
		<nav class="mt-2 infinite-list-wrapper" v-infinite-scroll="load" style="overflow:auto;border-radius: 0;"
			infinite-scroll-disabled="disabled">
			<ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
				<!-- Add icons to the links using the .nav-icon class
		           with font-awesome or any other icon font library -->
				<li class="nav-item" v-for="item in search_generals(name)" :key="item.id">
					<router-link :to="`/dashboard/${item.id}`" class="nav-link">
						<i class="nav-icon" :class="item.icon"></i>
						<p>
							{{ item.name }}
							<span class="right badge badge-info" :class="`badge-${item.shared ? 'warning' : 'info'}`"
								v-if="item.system || item.shared">{{ item.system ? '系统' : '公共' }}</span>
						</p>
					</router-link>
				</li>
			</ul>
		</nav>
		<!-- /.sidebar-menu -->
		<div class="row">
			<div v-if="loading" class="col-sm-12">
				<el-empty description="加载中...">
					<img slot="image" src="@/assets/logo.png" class="brand-image img-circle elevation-3"
						style="width: 32px;opacity: .8">
				</el-empty>
			</div>
		</div>
	</loge>
</template>

<script>
	import {
		mapActions,
		mapGetters
	} from 'vuex'
	import loge from '@/views/components/logo.vue'

	export default {
		components: {
			loge
		},
		data() {
			return {
				name: '',
				loading: false,
			}
		},
		computed: {
			...mapGetters('mine/generals', [
				'search_generals', 'noMore'
			]),
			disabled() {
				return this.loading || this.noMore
			}
		},
		methods: {
			...mapActions('mine/generals', [
				'get_mine_generals'
			]),
			load() {
				this.loading = true
				this.get_mine_generals({}).then(() => {
					this.loading = false
				})
			},
		}
	}
</script>
